import React from 'react';
import { FormattedMessage } from 'react-intl';
import { css } from 'aphrodite/no-important';
import { Payment } from 'packages/hooks/api/useFetchJourneys';

import messages from '../messages';

import styles from './styles';

interface Props {
  payment: Payment;
  isCurrent: boolean;
}

export const PaymentDetail = ({ payment, isCurrent }: Props) => (
  <div className={css(styles.container)}>
    <section className={css(styles.cardInfo)}>
      <h4 className={css(styles.title)}>
        <FormattedMessage {...messages.paymentType} />
      </h4>
      {payment?.paymentDetails?.paymentType}
      {payment?.paymentDetails?.card?.tokenisedCardNumber && (
        <>
          <p>{payment.paymentDetails?.card.type}</p>
          <p>{payment.paymentDetails?.card.tokenisedCardNumber}</p>
        </>
      )}
    </section>
    <section className={css(styles.orderId)}>
      <h4 className={css(styles.title)}>
        <FormattedMessage {...(isCurrent ? messages.ongoingOrderId : messages.orderId)} />
      </h4>

      {payment.paymentDetails?.orderId}
    </section>
  </div>
);

export default PaymentDetail;
